<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <section ref="scrollElement" :class="containerStyles">
    <div
      class="container mx-auto flex flex-col items-center justify-center"
      v-for="(expert, index) in expertArray"
      :key="index"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
        <header2
          v-if="expert?.title"
          :text="expert?.title"
          :is-umbraco="isUmbraco"
          :theme="themeType"
          classes="col-start-1 col-span-12 lg:col-start-7 lg:col-span-5  mb-3"
        />
        <paragraph
          v-if="expert?.jobDescription"
          :is-umbraco="isUmbraco"
          :theme="themeType"
          :text="expert?.jobDescription"
          classes="col-start-1 col-span-12 lg:col-start-7 lg:col-span-5 font-bold"
        />
        <rich-text
          v-if="expert?.content"
          :is-umbraco="isUmbraco"
          :theme="themeType"
          :text="expert?.content"
          classes="col-start-1 col-span-12 lg:col-start-7 lg:col-span-5 font-bold group lg:order-2"
        />
      </div>
      <div
        class="col-start-1 col-span-12 lg:col-start-2 lg:col-span-4 lg:row-start-1 lg:row-span-4 w-full h-auto mb-10"
      >
        <custom-image
          v-if="expert?.image"
          :alt="expert?.imageAltText"
          :image="expert?.image"
          :theme="theme"
          classes="w-full h-full object-cover"
          loading="eager"
        />
      </div>
      <div
        class="col-start-1 col-span-12 lg:col-start-7 lg:col-span-5 flex flex-col lg:mt-16"
      >
        <a
          :href="'mailto:' + expert?.email"
          class="w-full group lg:order-2"
          target="_blank"
        >
          <paragraph
            v-if="expert?.email"
            classes="font-bold group-hover:text-orange"
            :text="expert?.email"
            :is-umbraco="isUmbraco"
            :theme="themeType"
          />
        </a>

        <a :href="'tel:' + expert?.phone" class="w-full lg:order-3 group">
          <paragraph
            v-if="expert?.phone"
            classes="font-bold group-hover:text-orange"
            :text="expert?.phone"
            :is-umbraco="isUmbraco"
            :theme="themeType"
          />
        </a>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, toRefs, onMounted, onUnmounted, ref, Ref, watch } from "vue";
import { changeTheme, getThemeType } from "@/util/helper";
import { onIntersect } from "@/composables/onIntersect";
import { IRegionalExpertsModuleProps } from "@/types/components/IRegionalExpertModuleProps";
import Paragraph from "@components/Typography/Paragraph.ce.vue";
import CustomImage from "@atoms/Image/Img.vue";
import Header2 from "@components/Typography/Header2.ce.vue";
import RichText from "@components/Typography/RichText.ce.vue";
import { IExpertDataProperties } from "@/types/IExpertComponent";
import { IDescription, IImage } from "@/types/types";

const props = withDefaults(defineProps<IRegionalExpertsModuleProps>(), {
  isUmbraco: false,
});

const { theme, isUmbraco, expertList } = toRefs(props);

const observer: Ref<IntersectionObserver | null> = ref(null);
const scrollElement = ref(null);
const contentText: Ref<string | IDescription> = ref("");

const onEnter = () => {
  changeTheme(theme.value);
};
const onExit = () => {};

onMounted(() => {
  observer.value = onIntersect(scrollElement.value, onEnter, onExit, false, {
    threshold: 0.6,
  });
});

onUnmounted(() => {
  if (!observer.value) return;
  observer.value.disconnect();
});

watch(theme, (value) => {
  if (!value) return;
  changeTheme(value);
});

const themeType = computed(() => {
  return getThemeType(theme.value);
});

const containerStyles = computed(() => {
  const bgColor = isUmbraco?.value ? `bg-${theme.value}` : "";
  return `${bgColor} sectionContainer py-20`;
});

const expertArray = computed(() => {
  return JSON.parse(expertList.value);
});

// const expertImage = computed(() => {
//   if (!expert.value?.image) return;
//   if (!isUmbraco.value) {
//     const image = (expert.value.image?.[0] as IImage) ?? null;
//     return JSON.stringify(image);
//   }
//   const expertJson = JSON.parse(expert.value);
//   const imageData = JSON.parse(expertJson[0]?.properties?.image) as IImage;
//   return JSON.stringify(imageData);
// });

// const content = computed(() => {
//   if (!expert.value?.content) return;
//   if (!isUmbraco.value) {
//     contentText.value = expert.value.content.markup;
//   } else {
//     contentText.value = expert.value.content;
//   }
//   return contentText.value;
// });
</script>
